import { CustomEvent as CustomEventEnum } from '../enums/customEvent'

export const dispatchCustomEvent = <T = any>(eventName: CustomEventEnum, eventDetail?: T) => {
  const event = new CustomEvent(eventName, { detail: eventDetail })
  window.dispatchEvent(event)
}
